/**
 * Global switch to enable refi
 */
export const ENABLE_REFI = false;
